export const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://admin.shramjivicorp.com' 
  : 'http://localhost:5000';
